// Admin CMS

import React, { useEffect, useState } from "react";
import Dashboard from "../../../../common/dashboard-components/dashboard.component";
import AddButton from "../../../../reusable-components/buttons/AddButton";
import H2withIcon from "../../../../reusable-components/headings/H2withIcon";
import SpinnerWithText from "../../../../reusable-components/loader/SpinnerWithText";
import { IconContext } from "react-icons";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { ABOUT_US_GRATITUDE_CONFIG_URL } from "../../../../api/api_routing_urls";
import { ToastContainer } from "react-toastify";
import showToast from "../../../../utilities/notification/NotificationModal";
// import useAxiosPrivate from "../../../../authentication/hooks/useAxiosPrivate";
import axios from "../../../../api/axios";
import ContainerShadow from "../../../../reusable-components/containers/ContainerShadow";
import AddAboutUs from "./addAboutUs.component";
// import useAuth from "../../../../authentication/hooks/useAuth";

const AboutUsAdmin = () => {
  // const { auth } = useAuth();

  const [showAddForm, setShowAddForm] = useState(false);
  const [aboutUs, setAboutUs] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  // const axiosPrivate = useAxiosPrivate();

  const isEdit =
    aboutUs !== undefined ? Object.keys(aboutUs).length > 0 : false;

  const getAboutUsDetails = async () => {
    try {
      const response = await axios.get(ABOUT_US_GRATITUDE_CONFIG_URL);

      // let sanitized = "";
      // if (response.data.aboutUsDetails?.aboutuscontent !== undefined) {
      //   sanitized = sanitizeHtml(response.data.aboutUsDetails.aboutuscontent);
      //   response.data.aboutUsDetails.aboutuscontent = sanitized;
      // }
      response.status === 200 && setAboutUs(response?.data?.aboutUsDetails);
      response.status === 202 &&
        showToast("About Gratitude details not found in the system.", "error");
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        showToast("No Server Response");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;
    isMounted && getAboutUsDetails();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Dashboard>
      <ToastContainer />
      <div className="flex items-center justify-between">
        <H2withIcon>
          <IconContext.Provider value={{ className: "text-black" }}>
            <BsFillInfoCircleFill />
          </IconContext.Provider>
          &nbsp; About Us - Gratitude
        </H2withIcon>
        {!showAddForm && (
          <AddButton
            label={`${
              isEdit
                ? "Update About Us - Gratitude"
                : "Add About Us - Gratitude"
            }`}
            onclick={() => setShowAddForm(true)}
          />
        )}
      </div>
      {showAddForm ? (
        <AddAboutUs
          getAboutUsDetails={getAboutUsDetails}
          aboutUs={aboutUs}
          setAboutUs={setAboutUs}
          setShowAddForm={setShowAddForm}
        />
      ) : (
        <ContainerShadow>
          {!isEdit ? (
            <p>About Us content yet to be added!</p>
          ) : (
            <div>
              <br />
              <label>
                About Us:
                <br />
              </label>
              <div
                dangerouslySetInnerHTML={{
                  __html: aboutUs.about_us_content,
                }}
              />
            </div>
          )}
        </ContainerShadow>
      )}
    </Dashboard>
  );
};

export default AboutUsAdmin;
